import { useEffect } from "react";
import { useImmer } from "use-immer";
import ApiConnector from "../connector/ApiConnector";
import moment from "moment/moment";

const Component = (props) => {
  const [data, updateDate] = useImmer(null);

  useEffect(async () => {
    const cache = await ApiConnector.getLatestCache("SuccessStatisticsCache");
    if (cache.content) {
      updateDate(cache.content);
    }
  }, []);

  return (
    <>
      <header className="subheader header-with-save">
        <h1>Dashboard - Statistics</h1>
      </header>
      <main>
        {data && (
          <>
            <h2>Success rate per month</h2>
            <table className="config-table-double">
              <thead>
                <tr>
                  <th>Attribute</th>

                  {data.successStatistics.map((s, idx) => (
                    <>
                      {(idx === 0 && <th>Last 30 days</th>) || (
                        <th>{moment(s.trnDateMin).format("YYYY-MM")}</th>
                      )}
                    </>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Confirmed frauds</td>
                  {data.successStatistics.map((s) => (
                    <td>{s.totalFrauds}</td>
                  ))}
                </tr>
                <tr>
                  <td>True positives</td>
                  {data.successStatistics.map((s) => (
                    <td>{s.truePositives}</td>
                  ))}
                </tr>
                <tr>
                  <td>False positives</td>
                  {data.successStatistics.map((s) => (
                    <td>{s.falsePositives}</td>
                  ))}
                </tr>
                <tr>
                  <td>Effective frauds</td>
                  {data.successStatistics.map((s) => (
                    <td>{s.totalEffectiveFrauds}</td>
                  ))}
                </tr>
                <tr>
                  <td>Effective true positives</td>
                  {data.successStatistics.map((s) => (
                    <td>{s.effectiveTruePositives}</td>
                  ))}
                </tr>
                <tr>
                  <td>Effective false positives</td>
                  {data.successStatistics.map((s) => (
                    <td>{s.effectiveFalsePositives}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </>
        )}
      </main>
    </>
  );
};

export default Component;
